<template>
    <div class="dashboard">
        <v-row class="d-md-flex align-center">
            <v-col><h1>{{ $t('dashboard') }}</h1></v-col>
            <v-col cols="12" md="1" class="d-flex justify-end">
            </v-col>
            <v-col class="filter-box d-flex justify-end" cols="12" md="4">
                <v-btn class="btn-two mr-3" color="#08a657" height="56px" depressed
                       @click.stop="toggleFiltre()"
                >
                    <v-icon medium>mdi-filter-outline</v-icon>
                    {{ $t('filter') }}
                </v-btn>

                <v-btn class="btn-two" color="#08a657" height="56px" depressed
                       @click.stop="toggleCompare()"
                >
                    <v-icon medium>mdi-compare</v-icon>
                    {{ $t('compare') }}
                </v-btn>
            </v-col>

        </v-row>
        <v-row>
            <v-col class="py-0">
                <v-chip
                        v-if="dateTimeBegin && dateTimeEnd"
                        class="ma-1"
                        close
                        @click:close="removeFilterDate()"
                        small
                >
                    <strong>{{ $t('dash.dateRange') }}</strong>: {{ dateTimeBegin}} / {{ dateTimeEnd }}
                </v-chip>

                <v-chip
                        v-if="selectedOrganization.id"
                        class="ma-1"
                        close
                        @click:close="removeFilterOrganisation()"
                        small
                >
                    <strong>{{ $t('organizations') }}</strong>: {{organisationName}}
                </v-chip>

                <v-chip
                        v-if="(dateTimeBegin && dateTimeEnd) || selectedOrganization"
                        class="ma-1"
                        close
                        @click:close="removeFilterAll()"
                        small
                        outlined
                >
                    <strong>{{ $t('clear') }}</strong>
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-expand-transition>
                    <div class="transition-display brd-top-vone" v-show="showFilter">
                        <v-card>
                            <v-card-text>
                                <DashboardFilter
                                        :applyFilter="applyFilter"
                                        :cancelFilter="cancelFilter"
                                        :dateTimeBegin="dateTimeBegin"
                                        :dateTimeEnd="dateTimeEnd"
                                        :allOrganizations="allOrganizations"
                                        :selectedOrganization="selectedOrganization"
                                        :subsidiaries="subsidiaries"
                                        :changeSelectedSubsidiaries="changeSelectedSubsidiaries"
                                />
                            </v-card-text>
                        </v-card>
                    </div>
                </v-expand-transition>
            </v-col>

            <v-col cols="12" sm="3" v-for="item in dashboadFields" :key="item.id">
                <DashboardItem :item="item"/>
            </v-col>

        </v-row>
    </div>
</template>

<script>
    import config from '../../config'
    import Axios from 'axios'

    import DashboardFilter from "./DashboardFilter";
    import DashboardItem from "./DashboardItem";

    const qs = require('querystring')

    export default {
        components: {DashboardFilter, DashboardItem},
        name: "Dashboard",
        props: [],
        data() {
            return {
                showFilter: false,
                allOrganizations: [],
                dashboadFields: [
                    {id: 0, t: 'dash.cmrs', name: 'count', val: ''},
                    {id: 1, t: 'dash.assigned', name: 'assignedCount', val: ''},
                    {id: 2, t: 'dash.signedByDriver', name: 'signedByDriverCount', val: ''},
                    {id: 3, t: 'dash.signedByReceiver', name: 'signedByReceiverCount', val: ''},

                    {id: 4, t: 'dash.latePickup', name: 'latePickupCount', val: ''},
                    {id: 5, t: 'dash.totalTimeLatePickup', name: 'latePickupTime', val: ''},
                    {id: 6, t: 'dash.lateDelivery', name: 'lateDeliveryCount', val: ''},
                    {id: 7, t: 'dash.totalTimeLateDelivery', name: 'lateDeliveryTime', val: ''},

                    {id: 8, t: 'dash.remarksSender', name: 'senderRemarksCount', val: ''},
                    {id: 9, t: 'dash.remarksDriver', name: 'driverRemarksCount', val: ''},
                    {id: 10, t: 'dash.remarksReceiver', name: 'receiverRemarksCount', val: ''},

                    {id: 11, empty: true},

                    {id: 12, t: 'dash.activeDrivers', name: 'activeDriversCount', val: ''},
                    {id: 13, t: 'dash.activeSigners', name: 'activeSignersCount', val: ''},
                ],
                dateTimeBegin: '',
                dateTimeEnd: '',
                selectedOrganization: {},
                subsidiaries: false
            }
        },
        computed: {
            organisationName() {
                return this.allOrganizations.filter( el => el.id === this.selectedOrganization.id)[0].name
            }
        },
        methods: {
            changeSelectedSubsidiaries(v) {
                this.subsidiaries = v
            },
            applyFilter(dateStart = '', dateEnd = '', organisation, subsidiaries) {
                this.dateTimeBegin = dateStart;
                this.dateTimeEnd = dateEnd;
                this.selectedOrganization = organisation;
                this.subsidiaries = subsidiaries
                this.getDashboardInfo();
                this.toggleFiltre();
            },
            cancelFilter() {
                this.subsidiaries = false
                this.setCurrentMonth();
                this.selectedOrganization = {};
                this.getDashboardInfo();
                this.toggleFiltre();
            },
            getAllOrganizatios() {
                let payload = Object.assign({}, this.payload);
                payload.Limit = 9999999;
                Axios.post(config.apiBaseUrl + 'api/organization/list', qs.stringify(payload), {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(response => {
                        if (response.status === 200) {
                            this.allOrganizations = response.data.data
                        }
                    })
                    .catch(error => {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            getDashboardInfo() {
                const params = {
                    begin: this.dateTimeBegin,
                    end: this.dateTimeEnd,
                    organizationId: this.subsidiaries ? null : this.selectedOrganization.id,
                    organizationHId: this.subsidiaries ? this.selectedOrganization.organizationsHId : null
                }
                Axios.get(config.apiBaseUrl + `api/cmr/dashboard?${qs.stringify(params)}`, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(({status, data}) => {
                        if (status === 200) {
                            this.dashboadFields = this.dashboadFields.map(el => {
                                el.val = data[el.name];
                                return el;
                            });
                        }
                    })
                    .catch(error => {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            toggleFiltre() {
                this.showFilter = !this.showFilter;
            },

            toggleCompare() {
                this.$router.push({name: 'compare'})
            },

            setCurrentMonth() {
                const date = new Date();
                const y = date.getFullYear(),
                    m = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1,
                    d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.dateTimeBegin = `${y}-${m}-01`;
                this.dateTimeEnd = `${y}-${m}-${d}`;
            },
            removeFilterDate() {
                this.dateTimeBegin = '';
                this.dateTimeEnd = '';
                this.getDashboardInfo();
            },
            removeFilterOrganisation() {
                this.selectedOrganization = {};
                this.getDashboardInfo();
            },
            removeFilterAll() {
                this.dateTimeBegin = '';
                this.dateTimeEnd = '';
                this.selectedOrganization = {};
                this.getDashboardInfo();
            }

            //------------ end methods
        },
        created() {
            this.setCurrentMonth();
            this.getAllOrganizatios();
            this.getDashboardInfo();
        },

    }
</script>